export default __webpack_public_path__ + "static/media/studio-set-up-hover.fe9321e2.svg";